/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 14V10M18 14H14M18 14C18 14 15 10 11.5 10C7 10 6 14 6 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 14V10M18 14H14M18 14C18 14 15 10 11.5 10C7 10 6 14 6 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM11.5001 9.25C8.98974 9.25 7.41213 10.3804 6.48048 11.5271C6.02192 12.0914 5.72372 12.6533 5.53951 13.0744C5.44704 13.2857 5.38223 13.464 5.33967 13.5929C5.31837 13.6574 5.30256 13.7097 5.29159 13.7478C5.2861 13.7669 5.28182 13.7825 5.27866 13.7943L5.27475 13.8091L5.2734 13.8143L5.27288 13.8164L5.27265 13.8173C5.27255 13.8177 5.27245 13.8181 6.00006 14L5.27245 13.8181C5.17199 14.2199 5.41631 14.6271 5.81816 14.7276C6.21906 14.8278 6.62528 14.5849 6.72695 14.1847L6.72696 14.1847L6.72709 14.1842L6.72748 14.1828L6.73319 14.1623C6.73907 14.1419 6.74914 14.1083 6.76396 14.0634C6.79367 13.9735 6.84214 13.8393 6.91374 13.6756C7.05765 13.3467 7.2907 12.9086 7.64465 12.4729C8.33799 11.6196 9.51039 10.75 11.5001 10.75C12.9804 10.75 14.4332 11.6084 15.5795 12.5737C15.8521 12.8033 16.1008 13.0333 16.321 13.25H14.0001C13.5858 13.25 13.2501 13.5858 13.2501 14C13.2501 14.4142 13.5858 14.75 14.0001 14.75H18.0001C18.4143 14.75 18.7501 14.4142 18.7501 14V10C18.7501 9.58579 18.4143 9.25 18.0001 9.25C17.5858 9.25 17.2501 9.58579 17.2501 10V12.0611C17.0365 11.8557 16.8008 11.6412 16.5457 11.4263C15.3169 10.3916 13.5197 9.25 11.5001 9.25ZM6.72733 14.1832L6.72748 14.1828L6.72749 14.1826L6.72733 14.1832Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M18 14V10M18 14H14M18 14C18 14 15 10 11.5 10C7 10 6 14 6 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 14V10M18 14H14M18 14C18 14 15 10 11.5 10C7 10 6 14 6 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.48059 11.5271C7.41224 10.3804 8.98985 9.25 11.5002 9.25C13.5198 9.25 15.3171 10.3916 16.5458 11.4263C16.8009 11.6412 17.0366 11.8557 17.2502 12.0611V10C17.2502 9.58579 17.586 9.25 18.0002 9.25C18.4144 9.25 18.7502 9.58579 18.7502 10V14C18.7502 14.4142 18.4144 14.75 18.0002 14.75H14.0002C13.586 14.75 13.2502 14.4142 13.2502 14C13.2502 13.5858 13.586 13.25 14.0002 13.25H16.3211C16.1009 13.0333 15.8522 12.8033 15.5796 12.5737C14.4333 11.6084 12.9805 10.75 11.5002 10.75C9.5105 10.75 8.33811 11.6196 7.64476 12.4729C7.29081 12.9086 7.05777 13.3467 6.91386 13.6756C6.84226 13.8393 6.79379 13.9735 6.76408 14.0634C6.74925 14.1083 6.73918 14.1419 6.73331 14.1623L6.72759 14.1828L6.72761 14.1826C6.72743 14.1833 6.72725 14.184 6.72707 14.1847C6.72717 14.1843 6.72735 14.1837 6.72759 14.1828L6.72745 14.1832L6.7272 14.1842L6.72698 14.1851C6.72699 14.185 6.72702 14.1849 6.72707 14.1847C6.6254 14.5849 6.21917 14.8278 5.81828 14.7276C5.41643 14.6271 5.17211 14.2199 5.27257 13.8181L6.00018 14C5.27257 13.8181 5.27267 13.8177 5.27277 13.8173L5.273 13.8164L5.27352 13.8143L5.27486 13.8091L5.27877 13.7943C5.28193 13.7825 5.28622 13.7669 5.2917 13.7478C5.30267 13.7097 5.31848 13.6574 5.33979 13.5929C5.38235 13.464 5.44716 13.2857 5.53962 13.0744C5.72383 12.6533 6.02204 12.0914 6.48059 11.5271Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
